import { removeAuthAction } from "@redux/auth/action";
import { useDispatch } from "react-redux";



export const useLogout = () => {
    const dispatch = useDispatch();

    return () => dispatch(removeAuthAction({redirect: '/login'}, 'Logout'));;
}